/*@flow*/
import nested from 'lib/nested';

export default function getCompanyId(): ID {
  const id = nested(window, 'CONFIG.ME.company_id', null);
  window.companyId = window.companyId || id;
  return id;
}
